// extracted by mini-css-extract-plugin
module.exports = {"emptyRoom":"empty-room_emptyRoom__1RfF8","imgOuter":"empty-room_imgOuter__1xiDx","_sm":"empty-room__sm__3mjHK","img":"empty-room_img__31jh6","link":"empty-room_link__1Gw33"};